import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'TransactionTypePipe'
})
export class TransactionTypePipe implements PipeTransform {

  private listObj = {
    0: 'Recharge',
    1: 'Deducted',
    2: 'Refund'
  };

  transform(value: number): string {
    console.log("transforming: ", value)
    return this.listObj.hasOwnProperty(value) ? this.listObj[value] : '';
  }

}
